/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateXcNotificationSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateXcNotificationSettingsInput;
}>;

export type UpdateXcNotificationSettingsMutation = {
  readonly __typename?: 'Mutation';
  readonly updateXcNotificationSettings?: {
    readonly __typename?: 'UpdateXcNotificationSettingsPayload';
    readonly xcNotificationSetting?: ReadonlyArray<{
      readonly __typename?: 'XcNotificationSetting';
      readonly isEnabled: boolean;
      readonly notificationType?: Types.EmailNotificationType | null;
      readonly notificationTypeDisplayName?: string | null;
    }> | null;
  } | null;
};

export type UpdateXcNotificationSettingsForUserMutationVariables = Types.Exact<{
  input: Types.UpdateXcNotificationSettingsForUserInput;
}>;

export type UpdateXcNotificationSettingsForUserMutation = {
  readonly __typename?: 'Mutation';
  readonly updateXcNotificationSettingsForUser?: {
    readonly __typename?: 'UpdateXcNotificationSettingsForUserPayload';
    readonly xcNotificationSetting?: ReadonlyArray<{
      readonly __typename?: 'XcNotificationSetting';
      readonly isEnabled: boolean;
      readonly notificationType?: Types.EmailNotificationType | null;
      readonly notificationTypeDisplayName?: string | null;
    }> | null;
  } | null;
};

export type XcNotificationSettingForUserQueryVariables = Types.Exact<{
  accountSubdomain: Types.Scalars['String']['input'];
  userId: Types.Scalars['UUID']['input'];
}>;

export type XcNotificationSettingForUserQuery = {
  readonly __typename?: 'Query';
  readonly xcNotificationSettingsForUser: ReadonlyArray<{
    readonly __typename?: 'XcNotificationSetting';
    readonly isEnabled: boolean;
    readonly notificationType?: Types.EmailNotificationType | null;
    readonly notificationTypeDisplayName?: string | null;
  }>;
};

export type XcNotificationSettingPartsFragment = {
  readonly __typename?: 'XcNotificationSetting';
  readonly isEnabled: boolean;
  readonly notificationType?: Types.EmailNotificationType | null;
  readonly notificationTypeDisplayName?: string | null;
};

export type XcNotificationSettingQueryVariables = Types.Exact<{ [key: string]: never }>;

export type XcNotificationSettingQuery = {
  readonly __typename?: 'Query';
  readonly xcNotificationSettings: ReadonlyArray<{
    readonly __typename?: 'XcNotificationSetting';
    readonly isEnabled: boolean;
    readonly notificationType?: Types.EmailNotificationType | null;
    readonly notificationTypeDisplayName?: string | null;
  }>;
};

export const XcNotificationSettingPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'XcNotificationSettingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'XcNotificationSetting' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTypeDisplayName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const UpdateXcNotificationSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateXcNotificationSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateXcNotificationSettingsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateXcNotificationSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xcNotificationSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notificationTypeDisplayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateXcNotificationSettingsMutationFn = Apollo.MutationFunction<
  UpdateXcNotificationSettingsMutation,
  UpdateXcNotificationSettingsMutationVariables
>;

/**
 * __useUpdateXcNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateXcNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateXcNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateXcNotificationSettingsMutation, { data, loading, error }] = useUpdateXcNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateXcNotificationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateXcNotificationSettingsMutation,
    UpdateXcNotificationSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateXcNotificationSettingsMutation,
    UpdateXcNotificationSettingsMutationVariables
  >(UpdateXcNotificationSettingsDocument, options);
}
export type UpdateXcNotificationSettingsMutationHookResult = ReturnType<
  typeof useUpdateXcNotificationSettingsMutation
>;
export type UpdateXcNotificationSettingsMutationResult =
  Apollo.MutationResult<UpdateXcNotificationSettingsMutation>;
export type UpdateXcNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateXcNotificationSettingsMutation,
  UpdateXcNotificationSettingsMutationVariables
>;
export const UpdateXcNotificationSettingsForUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateXcNotificationSettingsForUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateXcNotificationSettingsForUserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateXcNotificationSettingsForUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xcNotificationSetting' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notificationTypeDisplayName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateXcNotificationSettingsForUserMutationFn = Apollo.MutationFunction<
  UpdateXcNotificationSettingsForUserMutation,
  UpdateXcNotificationSettingsForUserMutationVariables
>;

/**
 * __useUpdateXcNotificationSettingsForUserMutation__
 *
 * To run a mutation, you first call `useUpdateXcNotificationSettingsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateXcNotificationSettingsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateXcNotificationSettingsForUserMutation, { data, loading, error }] = useUpdateXcNotificationSettingsForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateXcNotificationSettingsForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateXcNotificationSettingsForUserMutation,
    UpdateXcNotificationSettingsForUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateXcNotificationSettingsForUserMutation,
    UpdateXcNotificationSettingsForUserMutationVariables
  >(UpdateXcNotificationSettingsForUserDocument, options);
}
export type UpdateXcNotificationSettingsForUserMutationHookResult = ReturnType<
  typeof useUpdateXcNotificationSettingsForUserMutation
>;
export type UpdateXcNotificationSettingsForUserMutationResult =
  Apollo.MutationResult<UpdateXcNotificationSettingsForUserMutation>;
export type UpdateXcNotificationSettingsForUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateXcNotificationSettingsForUserMutation,
  UpdateXcNotificationSettingsForUserMutationVariables
>;
export const XcNotificationSettingForUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'XcNotificationSettingForUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accountSubdomain' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'xcNotificationSettingsForUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountSubdomain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'accountSubdomain' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationTypeDisplayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useXcNotificationSettingForUserQuery__
 *
 * To run a query within a React component, call `useXcNotificationSettingForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useXcNotificationSettingForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXcNotificationSettingForUserQuery({
 *   variables: {
 *      accountSubdomain: // value for 'accountSubdomain'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useXcNotificationSettingForUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    XcNotificationSettingForUserQuery,
    XcNotificationSettingForUserQueryVariables
  > &
    ({ variables: XcNotificationSettingForUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    XcNotificationSettingForUserQuery,
    XcNotificationSettingForUserQueryVariables
  >(XcNotificationSettingForUserDocument, options);
}
export function useXcNotificationSettingForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    XcNotificationSettingForUserQuery,
    XcNotificationSettingForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    XcNotificationSettingForUserQuery,
    XcNotificationSettingForUserQueryVariables
  >(XcNotificationSettingForUserDocument, options);
}
// @ts-ignore
export function useXcNotificationSettingForUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    XcNotificationSettingForUserQuery,
    XcNotificationSettingForUserQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  XcNotificationSettingForUserQuery,
  XcNotificationSettingForUserQueryVariables
>;
export function useXcNotificationSettingForUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        XcNotificationSettingForUserQuery,
        XcNotificationSettingForUserQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  XcNotificationSettingForUserQuery | undefined,
  XcNotificationSettingForUserQueryVariables
>;
export function useXcNotificationSettingForUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        XcNotificationSettingForUserQuery,
        XcNotificationSettingForUserQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    XcNotificationSettingForUserQuery,
    XcNotificationSettingForUserQueryVariables
  >(XcNotificationSettingForUserDocument, options);
}
export type XcNotificationSettingForUserQueryHookResult = ReturnType<
  typeof useXcNotificationSettingForUserQuery
>;
export type XcNotificationSettingForUserLazyQueryHookResult = ReturnType<
  typeof useXcNotificationSettingForUserLazyQuery
>;
export type XcNotificationSettingForUserSuspenseQueryHookResult = ReturnType<
  typeof useXcNotificationSettingForUserSuspenseQuery
>;
export type XcNotificationSettingForUserQueryResult = Apollo.QueryResult<
  XcNotificationSettingForUserQuery,
  XcNotificationSettingForUserQueryVariables
>;
export const XcNotificationSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'XcNotificationSetting' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'xcNotificationSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'XcNotificationSettingParts' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'XcNotificationSettingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'XcNotificationSetting' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notificationTypeDisplayName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useXcNotificationSettingQuery__
 *
 * To run a query within a React component, call `useXcNotificationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useXcNotificationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXcNotificationSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useXcNotificationSettingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    XcNotificationSettingQuery,
    XcNotificationSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<XcNotificationSettingQuery, XcNotificationSettingQueryVariables>(
    XcNotificationSettingDocument,
    options
  );
}
export function useXcNotificationSettingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    XcNotificationSettingQuery,
    XcNotificationSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<XcNotificationSettingQuery, XcNotificationSettingQueryVariables>(
    XcNotificationSettingDocument,
    options
  );
}
// @ts-ignore
export function useXcNotificationSettingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    XcNotificationSettingQuery,
    XcNotificationSettingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<XcNotificationSettingQuery, XcNotificationSettingQueryVariables>;
export function useXcNotificationSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        XcNotificationSettingQuery,
        XcNotificationSettingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  XcNotificationSettingQuery | undefined,
  XcNotificationSettingQueryVariables
>;
export function useXcNotificationSettingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        XcNotificationSettingQuery,
        XcNotificationSettingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<XcNotificationSettingQuery, XcNotificationSettingQueryVariables>(
    XcNotificationSettingDocument,
    options
  );
}
export type XcNotificationSettingQueryHookResult = ReturnType<typeof useXcNotificationSettingQuery>;
export type XcNotificationSettingLazyQueryHookResult = ReturnType<
  typeof useXcNotificationSettingLazyQuery
>;
export type XcNotificationSettingSuspenseQueryHookResult = ReturnType<
  typeof useXcNotificationSettingSuspenseQuery
>;
export type XcNotificationSettingQueryResult = Apollo.QueryResult<
  XcNotificationSettingQuery,
  XcNotificationSettingQueryVariables
>;
